import { jsx as _jsx } from "react/jsx-runtime";
import { ThemeProvider, useTheme } from "@mui/material/styles";
import { useMemo } from "react";
import { baseThemeOptions, moodysThemeCreator, } from "./utils";
export const MoodysThemeProvider = ({ children, themeOverrides, responsiveFontSizes, mode, }) => {
    let parentTheme = useTheme();
    if (!parentTheme.moodys) {
        parentTheme = baseThemeOptions;
    }
    const moodysThemeCreatorParams = {
        parentTheme,
        themeOverrides,
        responsiveFontSizes,
        mode,
    };
    const theme = useMemo(() => moodysThemeCreator(moodysThemeCreatorParams), [JSON.stringify(moodysThemeCreatorParams)]);
    return _jsx(ThemeProvider, { theme: theme, children: children });
};
//# sourceMappingURL=theme.js.map